import { css } from "@linaria/core";

export const THUMBNAIL_FADE_DURATION_MS = 150;

export const wrapperCls = css`
  margin: 0 10px 7px 10px;
`;

export const portalCls = css`
  display: flex;

  height: 45px;
  color: #000;
  text-decoration: none;
  font-family: var(--font-family);
`;

export const imgWrapperCls = css`
  width: 30px;
  margin-right: 10px;
`;

export const imgCls = css`
  display: block;
  width: 100%;

  &-enter {
    opacity: 0;

    &-active {
      opacity: 1;
      transition: opacity ${THUMBNAIL_FADE_DURATION_MS}ms linear;
    }
  }
`;

export const textWrapperCls = css`
  overflow: hidden;
`;

export const headingCls = css`
  margin: 0 0 -3px 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: #262626;
  font-size: calc(14 * var(--font-px));
  font-weight: 600;
  line-height: 1;

  transition: color 0.1s linear;

  .${wrapperCls}:hover & {
    color: var(--color-primary);
  }
`;

export const gradeLevelCls = css`
  color: #262626;
  font-size: calc(12 * var(--font-px));
  font-weight: 400;
  line-height: 2.25;
`;
